import { Box, createStyles, makeStyles } from '@material-ui/core';
import React from 'react';

type LayoutProps = {
  children: React.ReactNode;
};

const useStyles = makeStyles(({palette, spacing})=>createStyles({
  root: {
    minHeight: '100vh',
  }
}))

function Layout({ children}: LayoutProps) {
  const classes = useStyles()
  return (
    <Box className={classes.root}>
      <main>{children}</main>
    </Box>
  );
}

export default Layout;
